import { FeatureFlagKey } from '@/utils/featureFlags';
import { getFeatureFlagsFromEnv } from '@/utils/featureFlags';

/**
 * React hook to check if a feature flag is enabled
 * @param flagKey The feature flag key to check
 * @returns boolean indicating if the feature flag is enabled
 */
export function useFeatureFlag(flagKey: FeatureFlagKey): boolean {
  return getFeatureFlagsFromEnv()[flagKey].enabled;
}
